var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function camelToDash(str) {
    if (str === str.toLowerCase()) {
        return str;
    }
    return str.replace(/[A-Z]/g, function (m) { return "-".concat(m.toLowerCase()); });
}
export function generateStyleFromCtx(ctx, noBodyPadding) {
    if (noBodyPadding === void 0) { noBodyPadding = false; }
    return __assign({ padding: noBodyPadding
            ? undefined
            : ctx.bodyPadding.map(function (p) { return "".concat(p, "px"); }).join(' ') }, Object.fromEntries(Object.entries(ctx.theme).flatMap(function (_a) {
        var _b;
        var k = _a[0], v = _a[1];
        return [
            ["--".concat(camelToDash(k)), v],
            [
                "--".concat(camelToDash("".concat(k, "RgbComponents"))),
                ((_b = v.match(/rgb\((\d+, \d+, \d+)\)/)) === null || _b === void 0 ? void 0 : _b[1]) || undefined,
            ],
        ];
    })));
}
//# sourceMappingURL=index.js.map